export default async function DeletePurchaseOrder(id = 0) {

    let url = window.RealestateService + `/api/PurchaseOrder/DeletePurchaseOrder?id=${id}`

    let head = {
        "content-type": "application/json",
        "accept": "*/*",
        "Authorization": window.token
    }
    let response = await fetch(url, {
        method: "Delete",
        headers: head,
        // body:JSON.stringify(sendForm)
    }).then(res => res.json()).catch(res => res)

    return response
}